var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", fluid: "" } },
    [
      _c(
        "v-container",
        {
          staticClass: "px-0 pt-0 pb-4",
          staticStyle: { "min-width": "100%" },
          attrs: { "fill-height": "" }
        },
        [
          _c("v-layout", { attrs: { column: "", wrap: "" } }, [
            _c(
              "div",
              { staticClass: "text-xs-right pr-5" },
              [
                _c("v-icon", { attrs: { small: "", color: "primary" } }, [
                  _vm._v(_vm._s(_vm.coIcon))
                ]),
                _vm._v(" "),
                _c("strong", {
                  staticClass: "primary--text",
                  staticStyle: {
                    "word-wrap": "break-word",
                    "white-space": "pre-wrap"
                  },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.$t(
                        _vm.lblSetting.lblTicket[_vm.source.action_type],
                        _vm.coDynamicDataTranslation
                      )
                    )
                  }
                }),
                _vm._v(" "),
                _vm.isOpen && _vm.currentTicket.description
                  ? _c(
                      "div",
                      { staticStyle: { margin: "0 0 0 45%" } },
                      [
                        _c("br"),
                        _vm._v(" "),
                        _c("i", { staticClass: "primary--text" }, [
                          _vm._v(
                            _vm._s(_vm.$t(_vm.lblSetting.ticketDescription)) +
                              ": " +
                              _vm._s(_vm.currentTicket.description)
                          )
                        ]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("message-time-notif-status", {
                          attrs: { source: _vm.source }
                        })
                      ],
                      1
                    )
                  : _vm.source.close_action
                  ? [
                      _c("br"),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticStyle: { float: "right", margin: "7px 0" } },
                        [
                          _c("i", { staticClass: "primary--text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  _vm.lblSetting
                                    .ticketClosureReasonConversationName
                                )
                              ) +
                                ": " +
                                _vm._s(
                                  _vm.source.close_action.closure_reason.name
                                )
                            )
                          ]),
                          _vm._v(" "),
                          _c("br"),
                          _vm._v(" "),
                          _vm.source.close_action.fk_ticket_reason
                            ? _c("i", { staticClass: "primary--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.lblSetting
                                        .ticketReasonConversationName
                                    )
                                  ) +
                                    ": " +
                                    _vm._s(
                                      _vm.source.close_action.ticket_reason.name
                                    )
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.source.close_action.fk_ticket_reason
                            ? _c("br")
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.source.close_action.description
                            ? _c("i", { staticClass: "primary--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      _vm.lblSetting
                                        .ticketClosureReasonConversationDesc
                                    )
                                  ) +
                                    ": " +
                                    _vm._s(_vm.source.close_action.description)
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.source.close_action.description
                            ? _c("br")
                            : _vm._e(),
                          _vm._v(" "),
                          _c("message-time-notif-status", {
                            attrs: { source: _vm.source }
                          })
                        ],
                        1
                      )
                    ]
                  : [
                      _c("br"),
                      _vm._v(" "),
                      _c("message-time-notif-status", {
                        attrs: { source: _vm.source }
                      })
                    ]
              ],
              2
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f7798b6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f7798b6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/ticket/components/ticket-chat-message-request-quote-item/template.html
// module id = null
// module chunks = 